import { Form, FormItemProps } from 'antd'

import { ReactNode } from 'react'

import './FormItem.css'

type Props<T> = FormItemProps<T> & {
  children?: ReactNode
}

const FormItem = <T,>({ children, className, ...props }: Props<T>) => {
  return (
    <Form.Item
      className={`customFormItem ${className}`}
      {...props}
    >
      {children}
    </Form.Item>
  )
}

export default FormItem
